import { render, staticRenderFns } from "./BelafspraakButton.vue?vue&type=template&id=16966b4b&"
import script from "./BelafspraakButton.vue?vue&type=script&lang=js&"
export * from "./BelafspraakButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports